import { render } from "./VersionsPage.vue?vue&type=template&id=7f381083&scoped=true"
import script from "./VersionsPage.vue?vue&type=script&lang=js"
export * from "./VersionsPage.vue?vue&type=script&lang=js"

import "./VersionsPage.vue?vue&type=style&index=0&id=7f381083&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f381083"]])

export default __exports__